module.exports = __webpack_public_path__ + "img/ag.a2e58b1a.png";